import { html } from "lit-html"
import TagList from "./tag-list"

const AgencyRow = ({ name, tags, url }) => html`
  <div class="agency p-3 pb-0 relative flex flex-row flex-wrap">
    <div class="min-h-11 p-3 order-1">
      <a href=${url}>${name} </a>
      <p>${TagList(tags)}</p>
    </div>
    <hr class="divider m-3 mb-0 order-10" />
  </div>
`

export default AgencyRow
